import React from 'react';
import { wrapDisplayName } from 'recompose';
import fp from 'lodash/fp';
import { withClient, withRouter } from '@deerplusofficial/pos-hoc';

export default config => Component => {
  return fp.compose(
    withRouter(),
    withClient()
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithChannelGuard');

      componentDidMount() {
        const {
          channelId,
          client: { onLogout, channelId: cachedChannelId },
        } = this.props;

        if (channelId === cachedChannelId || fp.isUndefined(cachedChannelId))
          return;

        return onLogout();
      }

      render() {
        return <Component {...this.props} />;
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/assist/withChannelGuard.js